import { createAsyncThunk } from '@reduxjs/toolkit';
import { ServiceVendor } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchServiceVendor, FindServiceVendor } from './interface';

export const findServiceVendor = createAsyncThunk(
  'serviceVendor/find',
  async (values: FindServiceVendor, { rejectWithValue }) => {
    try {
      return await ServiceVendor.find({ query: values });
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createServiceVendor = createAsyncThunk(
  'serviceVendor/create',
  async (values: CreatePatchServiceVendor, { rejectWithValue }) => {
    try {
      return await ServiceVendor.create(values);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchServiceVendor = createAsyncThunk(
  'serviceVendor/patch',
  async ({ id, ...values }: CreatePatchServiceVendor, { rejectWithValue }) => {
    try {
      return await ServiceVendor.patch(id, values);
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
